import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
const app = createApp(App);
import { VueReCaptcha } from 'vue-recaptcha-v3'

// balão com o texto completo quando um rótulo (ex.: item de menu) não cabe e é cortado
import dicaTruncada from './directives/dicaTruncada';
app.directive('dica-truncada', dicaTruncada);

// bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// modals
import '@/assets/sass/components/custom-modal.scss';

// perfect scrollbar
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';

// Componente global de tabela
import AppDataTable from '@/components/AppDataTable.vue';

// Componente global de input de valor em R$
import InputValorBRL from '@/components/InputValorBRL.vue';

// Componente global de switch/toggle padronizado
import AppSwitch from '@/components/AppSwitch.vue';

//vue-meta
import { createHead } from '@vueuse/head';
const head = createHead();

//mult-select
import 'vue-multiselect/dist/vue-multiselect.css';

// Import styles
import 'vue-color/style.css';

//Sweetalert
import Swal from 'sweetalert2';
window.Swal = Swal;

// nouislider - later remove and add to page due to not working in page
import VueNouislider from 'vue3-nouislider';
import 'vue3-nouislider/dist/vue3-nouislider.css';

// vue input mask
import Maska from 'maska';

// smooth scroll
import { registerScrollSpy } from 'vue3-scroll-spy/dist/index';
registerScrollSpy(app, { offset: 118 });

//vue-i18n
import i18n from './i18n';

// datatables
import { ClientTable } from 'v-tables-3';

// json to excel
import vue3JsonExcel from 'vue3-json-excel';

//vue-wizard
import VueFormWizard from 'vue3-form-wizard';
import 'vue3-form-wizard/dist/style.css';

// set default settings
import appSetting from './app-setting';
window.$appSetting = appSetting;
window.$appSetting.init();

app.component('AppDataTable', AppDataTable);
app.component('InputValorBRL', InputValorBRL);
app.component('AppSwitch', AppSwitch);
app.use(store).use(router).use(i18n).use(PerfectScrollbar).use(VueNouislider).use(Maska).use(ClientTable).use(vue3JsonExcel).use(VueFormWizard).use(head).use(VueReCaptcha, { siteKey: '6LfJC3cqAAAAAKicCcO0A9ZudJcn8RsSjXFOYUoi' }).mount('#app');
